module.exports = __webpack_public_path__ + "img/18.b1d412a3.jpg";